/* eslint-disable */

import React from 'react';
import {
  Button,
  Container,
  Divider,
  Form,
  Grid as SemanticGrid,
  Header,
  Icon,
  Image,
  Input,
  Menu,
  Label,
  Segment,
  Dropdown,
  Search,
  TextArea,
  Checkbox,
  Modal,
  Accordion
} from 'semantic-ui-react';
import Common from './common';

import logo from '../images/logo.svg';
import './components.css';
import classNames from 'classnames';

let dropdownOptions = [
    { text: 'Published', value: 'published' },
    { text: 'Draft', value: 'draft' }
  ],
  tagOptions = [
    {
      text: 'Tour De Kids 2017',
      value: 'Tour De Kids 2017'
    },
    {
      text: 'Tour De Kids 2016',
      value: 'Tour De Kids 2016'
    }
  ],
  gridData = [
    {
      name: 'Tour De Kids 2017',
      type: 'Peer To Peer'
    },
    {
      name: 'Tax Appeal 2017',
      type: 'DIY'
    }
  ];

let verticalMenuItemsData = [
  { key: '1', name: 'link-1', content: 'Setup' },
  { key: '2', name: 'link-2', content: 'Fundraising' },
  { key: '3', name: 'link-3', content: 'Donations' },
  { key: '4', name: 'link-4', content: 'Other' }
];

let verticalMenuItems = verticalMenuItemsData.map((itemData) => (
  <Menu.Item
    key={itemData.key}
    active={itemData.key === '1'}
    as="a"
    name={itemData.name}
  >
    <Button circular compact size="small">
      {itemData.key}
    </Button>
    {itemData.content}
  </Menu.Item>
));

class WizardRadioField extends React.Component {
  state = {};
  handleHover = () => {
    this.setState({
      isHovered: !this.state.isHovered
    });
  };

  render() {
    const fieldClass = this.state.isHovered ? 'hovered' : '';
    return (
      <Form.Field
        onMouseEnter={this.handleHover}
        onMouseLeave={this.handleHover}
        className={
          (this.props.currSelection === this.props.checkboxValue
            ? 'checked'
            : '') +
          ' ' +
          fieldClass
        }
      >
        <Checkbox
          label={this.props.checkboxLabel}
          name="wizardRadio"
          value={this.props.checkboxValue}
          checked={this.props.currSelection === this.props.checkboxValue}
          onChange={this.props.onHandleChange}
          radio
        />
        {this.props.children}
      </Form.Field>
    );
  }
}

class WizardRadioGroup extends React.Component {
  state = {};
  handleChange = (e, { value }) => this.setState({ value });

  render() {
    const radioItemsData = [
      {
        value: 'appeal',
        label: 'Appeal',
        innerHTML: (
          <div className="input-sub">
            Collect once off donations geared around particular purpose.
            <br />
            <a href="#">View example</a>
          </div>
        )
      },
      {
        value: 'community',
        label: 'Community Fundraising',
        innerHTML: (
          <div className="input-sub">
            Empower supporters to start fundraising for your charity for any
            purpose.
            <br />
            <a href="#">View example</a>
          </div>
        )
      },
      {
        value: 'giveNow',
        label: 'Give now',
        innerHTML: (
          <div className="input-sub">
            Empower supporters to start fundraising for your charity for any
            purpose.
            <br />
            <a href="#">View example</a>
          </div>
        )
      },
      {
        value: 'events',
        label: 'Events',
        innerHTML: (
          <div className="input-sub">
            Empower supporters to start fundraising for your charity for a given
            purpose or event.
            <br />
            <a href="#">View example</a>
          </div>
        )
      }
    ];
    const radioItems = radioItemsData.map((itemData, index) => (
      <WizardRadioField
        currSelection={this.state.value}
        checkboxLabel={itemData.label}
        checkboxValue={itemData.value}
        onHandleChange={this.handleChange}
        fieldClickHandler={this.handleChange}
        key={index}
      >
        {itemData.innerHTML}
      </WizardRadioField>
    ));
    return (
      <Form>
        {radioItems}
        <div className="button-wrapper align-right">
          <Button primary type="submit">
            Get started
          </Button>
        </div>
      </Form>
    );
  }
}

class WizardModal extends React.Component {
  state = { modalOpen: false };

  handleOpen = () => this.setState({ modalOpen: true });

  handleClose = () => this.setState({ modalOpen: false });

  render() {
    const { open, closeOnEscape, closeOnRootNodeClick } = this.state;

    return (
      <div>
        <Button onClick={this.handleOpen} primary>
          Create campaign
        </Button>

        <Modal
          className="wizard"
          size="tiny"
          open={this.state.modalOpen}
          onClose={this.handleClose}
          dimmer="inverted"
        >
          <Modal.Content>
            <Modal.Description>
              <div className="button-wrapper align-right">
                <Button
                  icon="close"
                  circular
                  color="grey"
                  compact
                  size="mini"
                  onClick={this.handleClose}
                  className="close"
                />
              </div>
              <Header>What type of campaign do you want to create?</Header>
              <WizardRadioGroup />
            </Modal.Description>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

const rangeSelectOptions = [
  {
    text: 'Between',
    value: 'between'
  },
  {
    text: 'Outside of',
    value: 'outside'
  }
];
const statusSelectOptions = [
  {
    text: 'Draft',
    value: 'draft'
  },
  {
    text: 'Live',
    value: 'live'
  },
  {
    text: 'Disabled',
    value: 'disabled'
  }
];

const AmountForm = (
  <Form>
    <Form.Group grouped>
      <Form.Select options={rangeSelectOptions} placeholder="Between" />
      <Form.Group equal>
        <Form.Input width={8} name="fromAmount" placeholder="From" />
        <Form.Input width={8} name="toAmount" placeholder="To" />
      </Form.Group>
    </Form.Group>
  </Form>
);

const DateForm = (
  <Form>
    <Form.Group grouped>
      <Form.Select options={rangeSelectOptions} placeholder="Between" />
      <Form.Group equal>
        <Form.Input
          width={8}
          name="fromDate"
          placeholder="From"
          icon="calendar outline"
        />
        <Form.Input
          width={8}
          name="toDate"
          placeholder="To"
          icon="calendar outline"
        />
      </Form.Group>
    </Form.Group>
  </Form>
);

const StatusForm = (
  <Form>
    <Form.Group grouped>
      <Form.Select options={statusSelectOptions} placeholder="Live" />
      <strong>OR</strong>
      {statusSelectOptions.map((item, index) => (
        <Form.Checkbox key={`${item}-${index}`} label={item.text} />
      ))}
    </Form.Group>
  </Form>
);

const AccordenForms = [
  {
    name: 'amountForm',
    label: 'Amount',
    content: AmountForm
  },
  {
    name: 'dateForm',
    label: 'Date',
    content: DateForm
  },
  {
    name: 'statusForm',
    label: 'Status',
    content: StatusForm
  }
];

class GridFilterContext extends React.Component {
  state = {
    activeIndex: 1,
    showContext: false
  };

  onButtonClick = () => {
    this.setState({
      showContext: !this.state.showContext
    });
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { activeIndex } = this.state;
    const contextClass = classNames({
      open: this.state.showContext,
      context: true,
      'filter-context': true
    });

    return (
      <div className="filter">
        <Button primary onClick={this.onButtonClick}>
          Filter
        </Button>
        {this.state.showContext && (
          <div className={contextClass}>
            <Accordion vertical styled className="filter-context-accordeon">
              <SemanticGrid
                verticalAlign="middle"
                className="context-header"
                columns={3}
              >
                <SemanticGrid.Column textAlign="left">
                  <Button>Clear</Button>
                </SemanticGrid.Column>
                <SemanticGrid.Column textAlign="center">
                  <strong>Filter</strong>
                </SemanticGrid.Column>
                <SemanticGrid.Column textAlign="right">
                  <Button primary>Apply</Button>
                </SemanticGrid.Column>
              </SemanticGrid>
              {AccordenForms.map((item, index) => (
                <div key={index}>
                  <Accordion.Title
                    active={activeIndex === index}
                    index={index}
                    onClick={this.handleClick}
                  >
                    <Checkbox label={item.label} />
                  </Accordion.Title>
                  <Accordion.Content
                    active={activeIndex === index}
                    content={item.content}
                  />
                </div>
              ))}
            </Accordion>
          </div>
        )}
      </div>
    );
  }
}

const gridColumnsData = [
  {
    name: 'amount',
    label: 'Amount',
    visibilityStatus: true,
    disabled: true
  },
  {
    name: 'time',
    label: 'Time',
    visibilityStatus: true,
    disabled: false
  },
  {
    name: 'phone',
    label: 'Phone number',
    visibilityStatus: true,
    disabled: false
  },
  {
    name: 'address',
    label: 'Address',
    visibilityStatus: false,
    disabled: false
  }
];

class ColumnsToggle extends React.Component {
  state = {
    showContext: false,
    options: gridColumnsData.reduce(
      (o, key) => ({ ...o, [key.name]: key.visibilityStatus }),
      {}
    )
  };
  onButtonClick = () => {
    this.setState({
      showContext: !this.state.showContext
    });
  };
  onToggle = (e, data) => {
    let toggledCheckBox = data.name;
    this.setState(({ options }) => ({
      options: {
        ...options,
        [toggledCheckBox]: !this.state.options[toggledCheckBox]
      }
    }));
  };

  render() {
    const gridColumns = gridColumnsData;
    const contextClass = classNames({
      open: this.state.showContext,
      context: true,
      'toggle-columns-context': true
    });

    return (
      <div className="toggle-columns">
        <Button primary onClick={this.onButtonClick}>
          Toggle columns
        </Button>
        {this.state.showContext && (
          <div className={contextClass}>
            <Form>
              <Form.Group grouped>
                {gridColumns.map((item, index) => (
                  <Form.Checkbox
                    key={index}
                    name={item.name}
                    checked={this.state.options[item.name]}
                    onChange={this.onToggle}
                    label={item.label}
                    disabled={item.disabled}
                  />
                ))}
              </Form.Group>
            </Form>
          </div>
        )}
      </div>
    );
  }
}

export default class ComponentsPage extends React.Component {
  constructor(props) {
    super();
    this.state = {
      color: '#ED3632'
    };
  }

  onColorChange(value) {
    this.setState({
      color: value
    });
  }

  render() {
    return (
      <div>
        <Menu className="main-menu" pointing secondary fixed="top">
          <img src={logo} className="logo" alt="logo" />
          <Menu.Item position="right" active>
            Campaigns
          </Menu.Item>
          <Menu.Item>Donations</Menu.Item>
          <Menu.Item>Payouts</Menu.Item>
          <Menu.Item>Accounts</Menu.Item>
          <Dropdown icon="chevron down" text="Hi James" className="link item">
            <Dropdown.Menu>
              <Dropdown.Item>Edit Profile</Dropdown.Item>
              <Dropdown.Item>Choose Language</Dropdown.Item>
              <Dropdown.Item>Account Settings</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Menu>
        <Container style={{ marginTop: '8em' }}>
          <Header as="h1">Elements dashboard</Header>

          <Header as="h2" dividing>
            UI elements
          </Header>

          <SemanticGrid columns={2} stackable>
            <SemanticGrid.Column>
              <Search value="" placeholder="Find a donation" />

              <Dropdown placeholder="Published" selection className="icon">
                <Dropdown.Menu>
                  {dropdownOptions.map((option) => (
                    <Dropdown.Item key={option.value} {...option} />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </SemanticGrid.Column>

            <SemanticGrid.Column>
              <Button>Toggle columns</Button>
              <Button primary>Create campaign</Button>
              <Button secondary>Button</Button>
            </SemanticGrid.Column>
          </SemanticGrid>

          <Header as="h2" dividing>
            Lookup component
          </Header>

          <SemanticGrid columns={2} stackable>
            <SemanticGrid.Column>
              <Common.Lookup data={tagOptions} />
            </SemanticGrid.Column>
          </SemanticGrid>

          <Header as="h2" dividing>
            Form builder component (plain HTML)
          </Header>

          <SemanticGrid columns={2} stackable>
            <SemanticGrid.Column>
              <Common.FormBuilderPlain
                heading="Shorthand approach"
                description="Prop array used for feilds generating. Select and customise the information that you wish to collect from your particiants when they create their fundraising page."
                formBuilderFields={[
                  { type: 'basic', typeName: 'Custom field', open: true },
                  { type: 'phone', typeName: 'Some other field', helper: true }
                ]}
              />
            </SemanticGrid.Column>
            <SemanticGrid.Column>
              <Common.FormBuilderPlain
                heading="Detailed approach"
                description="Children elements used. Select and customise the information that you wish to collect from your particiants when they create their fundraising page."
              >
                <Common.FormBuilderPlain.Field
                  open
                  type="phone"
                  typeName="Phone"
                  namePlaceholder="E.g. Work phone, Cellular phone"
                  helper
                  helperPlaceholder="E.g. Enter your phone in desired format"
                />
                <Common.FormBuilderPlain.Field
                  type="address"
                  typeName="Address"
                  namePlaceholder="E.g. Postal Address, Work address…"
                  helper
                  helperPlaceholder="E.g. So we know where to send your race bib."
                />
              </Common.FormBuilderPlain>
            </SemanticGrid.Column>
          </SemanticGrid>

          <Header as="h2" dividing>
            Form elements
          </Header>

          <SemanticGrid columns={2} stackable>
            <SemanticGrid.Column>
              <Form>
                <Form.Field>
                  <Checkbox label="Searchable" />
                  <div className="input-sub">
                    This page is searchable and will be visible on the campaign
                    page.
                  </div>
                </Form.Field>
                <Form.Field>
                  <Dropdown
                    placeholder="Published"
                    selection
                    options={dropdownOptions}
                  />
                </Form.Field>
                <Form.Field>
                  <label className="optional">Fundraising target</label>
                  <Input label="$" />
                  <div className="input-sub">
                    How much do you aim to raise for your campaign? Choose a
                    goal that you feel is achievable, you can always set your
                    target amount higher when your goal is reached.
                  </div>
                </Form.Field>
                <Form.Field
                  className={classNames({
                    hero: true,
                    avatar: false,
                    upload: true
                  })}
                >
                  <label>Hero image</label>
                  <Common.UploadC
                    hero
                    width="1500"
                    height="350"
                    format="PNG or JPG"
                  />
                  <div className="input-sub">
                    Your hero image is the first element to be seen when
                    visitors land on your page. Ensure that you use a good
                    quality, text free image that accurately represents your
                    campaign.{' '}
                  </div>
                </Form.Field>
              </Form>
            </SemanticGrid.Column>

            <SemanticGrid.Column>
              <Form>
                <Form.Field>
                  <label>Campaign name</label>
                  <Input placeholder="Blackmores Sydney Running Festival 2017" />
                  <div className="input-sub">
                    What are you raising money for?
                  </div>
                </Form.Field>
                <Form.Field required>
                  <label>Website URL</label>
                  <Input />
                </Form.Field>
                <Form.Field>
                  <label>Code Injection</label>
                  <TextArea />
                </Form.Field>
                <Form.Group unstackable className="donation-amounts">
                  <Form.Field width={2}>
                    <label>Default</label>
                    <Checkbox radio />
                  </Form.Field>
                  <Form.Field width={3}>
                    <label> </label>
                    <Input label="$" placeholder="10" />
                  </Form.Field>
                  <Form.Field width={8}>
                    <label>Description</label>
                    <Input fluid />
                  </Form.Field>
                </Form.Group>
                <Form.Field
                  fluid
                  className={classNames({
                    hero: false,
                    avatar: true,
                    upload: true
                  })}
                >
                  <label>Campaign photo</label>
                  <Common.UploadC
                    avatar
                    width="350"
                    height="350"
                    format="PNG or JPG"
                  />
                </Form.Field>
              </Form>
            </SemanticGrid.Column>
          </SemanticGrid>

          <Header as="h2" dividing>
            Text elements
          </Header>

          <SemanticGrid columns={2} stackable>
            <SemanticGrid.Column>
              <Header as="h1">I’m an H1 Heading</Header>
              <Header as="h2">I’m an H2 Heading</Header>
              <Header as="h3">I’m an H3 Heading</Header>
              <Header as="h4">I’m an H4 Heading</Header>
              <Header as="h5">I’m an H5 Heading</Header>
            </SemanticGrid.Column>

            <SemanticGrid.Column>
              <p>
                Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis
                natoque penatibus et magnis dis parturient montes, nascetur
                ridiculus mus. Nullam id dolor id nibh ultricies vehicula.
              </p>
              <p>
                Nullam quis risus eget <a href="#">urna mollis ornare</a> vel eu
                leo. Cum sociis natoque penatibus et magnis dis parturient
                montes, nascetur ridiculus mus. Nullam id dolor id nibh
                ultricies vehicula.
              </p>
              <p>
                <small>
                  This line of text is meant to be treated as fine print.
                </small>
              </p>
              <p>
                The following snippet of text is{' '}
                <strong>rendered as bold text</strong>.
              </p>
              <p>
                The following snippet of text is{' '}
                <em>rendered as italicized text</em>.
              </p>
              <p>
                An abbreviation of the word attribute is{' '}
                <abbr title="attribute">attr</abbr>.
              </p>
            </SemanticGrid.Column>
          </SemanticGrid>

          <Header as="h2" dividing>
            Modal
          </Header>

          <WizardModal />

          <Header as="h2" dividing>
            Menu
          </Header>

          <SemanticGrid doubling>
            <SemanticGrid.Row columns={2}>
              <SemanticGrid.Column>
                <Menu
                  items={[
                    { key: '1', name: 'link-1', content: 'Link' },
                    { key: '2', name: 'link-2', content: 'Link' },
                    { key: '3', name: 'link-3', content: 'Link' }
                  ]}
                  pointing
                  secondary
                />
              </SemanticGrid.Column>

              <SemanticGrid.Column>
                <Menu
                  items={[
                    { key: 'l1', name: 'link-1', content: 'Live (235)' },
                    { key: 'l2', name: 'link-2', content: 'Complete (3)' },
                    { key: 'l3', name: 'link-3', content: 'Draft (2)' }
                  ]}
                />
              </SemanticGrid.Column>
            </SemanticGrid.Row>
            <SemanticGrid.Row columns={3}>
              <SemanticGrid.Column>
                <Header as="h3">Menu component</Header>
                <Menu vertical fluid>
                  {verticalMenuItems}
                </Menu>
              </SemanticGrid.Column>
              <SemanticGrid.Column>
                <Header as="h3">Pager component (steps number)</Header>
                <Common.Pager>
                  {verticalMenuItemsData.map((item, index) => (
                    <Common.Pager.Item
                      stepsNumber
                      key={item.key}
                      id={item.name}
                      active={index === 0}
                    >
                      {item.content}
                    </Common.Pager.Item>
                  ))}
                </Common.Pager>
              </SemanticGrid.Column>
              <SemanticGrid.Column>
                <Header as="h3">Pager component (pointing)</Header>
                <Common.Pager>
                  {verticalMenuItemsData.map((item, index) => (
                    <Common.Pager.Item
                      pointing
                      key={item.key}
                      id={item.name}
                      active={index === 0}
                    >
                      {item.content}
                    </Common.Pager.Item>
                  ))}
                </Common.Pager>
              </SemanticGrid.Column>
            </SemanticGrid.Row>
          </SemanticGrid>

          <Header as="h2" dividing>
            Buttons
          </Header>

          <SemanticGrid columns="equal">
            <SemanticGrid.Column>
              <Button>Default</Button>
              <Button primary>Primary</Button>
              <Button secondary>Secondary</Button>
              <Button basic>Basic</Button>
              <Button compact>Compact</Button>

              <Divider />

              <Button icon="heart" />
              <Button content="Labeled" icon="heart" labelPosition="left" />
              <Button content="Labeled" icon="heart" labelPosition="right" />

              <Divider />

              <Button.Group>
                <Button>Combo</Button>
              </Button.Group>

              <Divider />

              <Button animated>
                <Button.Content visible>Horizontal</Button.Content>
                <Button.Content hidden>Hidden</Button.Content>
              </Button>
              <Button animated="vertical">
                <Button.Content visible>Vertical</Button.Content>
                <Button.Content hidden>Hidden</Button.Content>
              </Button>
              <Button animated="fade">
                <Button.Content visible>Fade In</Button.Content>
                <Button.Content hidden>Hidden</Button.Content>
              </Button>

              <Divider />

              <Button disabled>Disabled</Button>
              <Button loading>Loading</Button>

              <Divider />

              <Button.Group>
                <Button>1</Button>
                <Button>2</Button>
                <Button>3</Button>
              </Button.Group>

              <Button.Group>
                <Button icon="align left" />
                <Button icon="align center" />
                <Button icon="align right" />
                <Button icon="align justify" />
              </Button.Group>

              <Button.Group>
                <Button>1</Button>
                <Button.Or />
                <Button>2</Button>
              </Button.Group>

              <Divider />

              <Button.Group attached="top" widths={2}>
                <Button>One</Button>
                <Button>Two</Button>
              </Button.Group>
              <Segment attached>
                <Image src="/assets/images/wireframe/paragraph.png" />
              </Segment>
              <Button.Group attached="bottom" widths={2}>
                <Button>One</Button>
                <Button>Two</Button>
              </Button.Group>
            </SemanticGrid.Column>

            <SemanticGrid.Column>
              <Button size="mini">Mini</Button>
              <Button size="tiny">Tiny</Button>
              <Button size="small">Small</Button>
              <Button size="large">Large</Button>
              <Button size="big">Big</Button>
              <Button size="huge">Huge</Button>
              <Button size="massive">Massive</Button>

              <Divider />

              <Button color="yellow" style={{ marginBottom: '1em' }}>
                Yellow
              </Button>
              <Button color="orange" style={{ marginBottom: '1em' }}>
                Orange
              </Button>
              <Button color="green" style={{ marginBottom: '1em' }}>
                Green
              </Button>
              <Button color="teal" style={{ marginBottom: '1em' }}>
                Teal
              </Button>
              <Button color="blue" style={{ marginBottom: '1em' }}>
                Blue
              </Button>
              <Button color="purple" style={{ marginBottom: '1em' }}>
                Purple
              </Button>
              <Button color="pink" style={{ marginBottom: '1em' }}>
                Pink
              </Button>
              <Button color="red" style={{ marginBottom: '1em' }}>
                Red
              </Button>
              <Button color="black" style={{ marginBottom: '1em' }}>
                Black
              </Button>

              <Divider />

              <Segment inverted>
                <Button inverted>Inverted</Button>
                <Button basic inverted>
                  Basic
                </Button>
                <Button color="blue" inverted>
                  Colored
                </Button>
                <Button basic color="blue" inverted>
                  Basic Colored
                </Button>
              </Segment>
            </SemanticGrid.Column>
          </SemanticGrid>

          <Header as="h2" dividing>
            Colour Picker
          </Header>

          <SemanticGrid columns="equal">
            <SemanticGrid.Column>
              <Common.ColorPicker
                value={this.state.color}
                onChange={this.onColorChange.bind(this)}
              />
            </SemanticGrid.Column>
            <SemanticGrid.Column>
              <Common.CustomColorPicker
                value={this.state.color}
                onChange={this.onColorChange.bind(this)}
              />
            </SemanticGrid.Column>
          </SemanticGrid>

          <Header as="h2" dividing>
            Grid Filter And Columns Toggle Context
          </Header>

          <SemanticGrid columns="equal">
            <SemanticGrid.Column>
              <GridFilterContext />
            </SemanticGrid.Column>
            <SemanticGrid.Column>
              <ColumnsToggle />
            </SemanticGrid.Column>
          </SemanticGrid>

          <Header as="h2" dividing>
            Grids
          </Header>

          <SemanticGrid>
            <SemanticGrid.Column>
              <Header as="h4" dividing>
                Not Initialised / Not Loaded
              </Header>
              <Common.Grid data={gridData} sort="name" direction="asc">
                <Common.Grid.Column
                  id="name"
                  headerText="Name"
                  datatype="string"
                  sortable
                />
                <Common.Grid.Column
                  id="type"
                  headerText="Type"
                  datatype="string"
                  sortable
                />
              </Common.Grid>
            </SemanticGrid.Column>
          </SemanticGrid>

          <SemanticGrid>
            <SemanticGrid.Column>
              <Header as="h4" dividing>
                Initialised / Loading
              </Header>
              <Common.Grid
                data={gridData}
                initialised
                loading
                sort="name"
                direction="asc"
              >
                <Common.Grid.Column
                  id="name"
                  headerText="Name"
                  datatype="string"
                  sortable
                />
                <Common.Grid.Column
                  id="type"
                  headerText="Type"
                  datatype="string"
                  sortable
                />
              </Common.Grid>
            </SemanticGrid.Column>
          </SemanticGrid>

          <SemanticGrid>
            <SemanticGrid.Column>
              <Header as="h4" dividing>
                Initialised / Not Loading
              </Header>
              <Common.Grid
                data={gridData}
                initialised
                loading={false}
                sort="name"
                direction="asc"
              >
                <Common.Grid.Column
                  id="name"
                  headerText="Name"
                  datatype="string"
                  sortable
                />
                <Common.Grid.Column
                  id="type"
                  headerText="Type"
                  datatype="string"
                  sortable
                />
              </Common.Grid>
              <Common.Grid.Pagination recordCount={50} page={5} total={10} />
            </SemanticGrid.Column>
          </SemanticGrid>

          <SemanticGrid>
            <SemanticGrid.Column>
              <Header as="h4" dividing>
                Pagination
              </Header>
              <Common.Grid.Pagination recordCount={50} page={1} total={10} />
            </SemanticGrid.Column>
          </SemanticGrid>

        </Container>
      </div>
    );
  }
}
